import { defineMessages } from 'react-intl'

const scope = `procurify.components.VendorRequestInformation`

export default defineMessages({
  vendorRequestRequesterLabel: {
    id: `${scope}.vendorRequestRequesterLabel`,
    defaultMessage: 'Requester',
  },
  vendorRequestSubmittedDateLabel: {
    id: `${scope}.vendorRequestSubmittedDateLabel`,
    defaultMessage: 'Date submitted',
  },
  vendorRequestNextApproverLabel: {
    id: `${scope}.vendorRequestNextApproverLabel`,
    defaultMessage: 'Next approver',
  },
})
